import { render, staticRenderFns } from "./InvoicesList.vue?vue&type=template&id=7f8ef700"
import script from "./InvoicesList.vue?vue&type=script&lang=js"
export * from "./InvoicesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports